const STATUS_MAP = {
  "En attente": { cls: "warning", ico: "fa-hourglass-half" },
  "À vérifier": { cls: "info", ico: "fa-circle-question" },
  "Conforme": { cls: "primary", ico: "fa-circle-check" },
  // Établissements : alignés sur ESTABLISHMENT_STATUS (zorni-portal)
  MISSING_INFORMATIONS: { cls: "info", ico: "fa-circle-question", label: "Incomplet" },
  WAITING_FOR_APPROVAL: { cls: "warning", ico: "fa-hourglass-half", label: "En attente d'approbation" },
  ACTIVATED: { cls: "success", ico: "fa-circle-check", label: "Actif" },
  DISABLED: { cls: "neutral", ico: "fa-ban", label: "Désactivé" },
  "Publiée": { cls: "success", ico: "fa-circle-check" },
  "Confirmée": { cls: "success", ico: "fa-check" },
  "Annulée": { cls: "danger", ico: "fa-xmark" },
  "Terminée": { cls: "neutral", ico: "fa-flag-checkered" },
  "Remboursement demandé": { cls: "warning", ico: "fa-rotate-left" },
  "Remboursée": { cls: "info", ico: "fa-rotate-left" },
  "Nouveau": { cls: "info", ico: "fa-sparkles" },
  "En cours": { cls: "primary", ico: "fa-spinner" },
  "En attente client": { cls: "warning", ico: "fa-user-clock" },
  "En attente partenaire": { cls: "warning", ico: "fa-building" },
  "Résolu": { cls: "success", ico: "fa-check" },
  "Fermé": { cls: "neutral", ico: "fa-lock" },
  "Effectué": { cls: "success", ico: "fa-check" },
};

// Statuts partageant un même code enum entre domaines (ex: WAITING_FOR_APPROVAL
// existe pour les établissements ET les circuits, avec un libellé différent
// dans zorni-portal) : la map est scopée par domaine pour éviter la collision.
const DOMAIN_STATUS_MAP = {
  trip: {
    DRAFTS: { cls: "neutral", ico: "fa-pen", label: "Brouillon" },
    WAITING_FOR_APPROVAL: { cls: "warning", ico: "fa-hourglass-half", label: "En attente de validation" },
    PUBLISHED: { cls: "success", ico: "fa-circle-check", label: "Publié" },
    ARCHIVED: { cls: "neutral", ico: "fa-box-archive", label: "Archivé" },
  },
  // Tickets support : HelpRequestStatusEnum
  support: {
    OPEN: { cls: "info", ico: "fa-sparkles", label: "Nouveau" },
    IN_PROGRESS: { cls: "primary", ico: "fa-spinner", label: "En cours" },
    WAITING_ON_CUSTOMER: { cls: "warning", ico: "fa-user-clock", label: "En attente client" },
    RESOLVED: { cls: "success", ico: "fa-check", label: "Résolu" },
    CLOSED: { cls: "neutral", ico: "fa-lock", label: "Fermé" },
  },
};

export function StatusBadge({ statut, domain }) {
  const m = (domain && DOMAIN_STATUS_MAP[domain]?.[statut]) || STATUS_MAP[statut] || { cls: "neutral", ico: "fa-circle" };
  return (
    <span className={`badge ${m.cls}`}>
      <i className={`fa-solid ${m.ico}`}></i> {m.label || statut}
    </span>
  );
}

export default StatusBadge;
